export default "__VITE_ASSET__DSrg6JoE__"